// The default locale to use for renderers, filter inputs, etc.
// If undefined, the browser's locale will be used.
// Allows to modify the locale for testing purposes.
export const defaultLocale: string | undefined = undefined;
